:host {
  display: inline-block;
  font-family: var(--semantic-typography-font-family-primary), var(--font-fallbacks);

  .price__price-currency {
    font-style: normal;
  }

  .pricing__top {
    display: flex;
    flex-direction: column;
  }

  .pricing__header {
    display: inline-flex;
    width: 100%;
    font-size: var(--pricing--header--fs, var-rem(--semantic-typography-font-size-xs));
    line-height: var(--pricing--header--lh, var-rem(--semantic-typography-line-height-caption-md));

    &.price-align__center {
      justify-content: center;
    }

    &.price-align__right {
      justify-content: flex-end;
    }

    .pricing__starting-from {
      display: inline-block;
      margin-right: var-rem(--semantic-spacing-3xs);
      color: var(--pricing--price-patch-color, var(--semantic-color-text-subtle));
    }

    .pricing__promo-price {
      font-size: var(--pricing--price-promo-price--fs, var-rem(--semantic-typography-font-size-xs));
      line-height: var(--pricing--price-promo-price--lh, var-rem(--semantic-typography-line-height-caption-md));
      display: inline-flex;
      color: var(--pricing--price-patch-color, var(--semantic-color-text-subtle));
      text-decoration: line-through;
    }
  }

  .pricing__current-price-wrapper {
    display: flex;
    align-items: baseline;

    &.price-align__right,
    &.price-align__center {
      flex-direction: column;

      .pricing__price-frequency {
        margin-right: 0;
      }
    }

    &.price-align__center {
      align-items: center;
    }

    &.price-align__right {
      align-items: flex-end;
    }

    .pricing__price-value-wrapper {
      align-items: flex-start;
      font-weight: var(--pricing--price-value-wrapper--fw, var(--semantic-components-pricing-typography-font-weight-sm));
      color: var(--pricing--price-patch-color, var(--semantic-color-text-default));
      font-family: var(--semantic-components-pricing-typography-font-family);
      padding: var(--pricing--price-value-wrapper--padding, var-rem(--semantic-spacing-3xs) var-rem(--semantic-spacing-none));
      margin-top: var(--pricing--price-value-wrapper--margin, var-rem(--semantic-spacing-none));

      @include media('from-lg') {
        font-weight: var(--pricing--price-value-wrapper--fw, var(--semantic-components-pricing-typography-font-weight-md));
      }

      &.highlighted-price {
        color: var(--semantic-color-text-promo-pricing);
      }

      .price__price-currency {
        font-size: var(--pricing--price-currency--fs, var-rem(--semantic-components-pricing-typography-font-size-currency-md));
        font-style: normal;
        line-height: var(--pricing--price-currency--ls, var-rem(--semantic-components-pricing-typography-line-height-currency-md));
      }

      .price__price-decimal {
        font-size: var(--price--price-decimal--fs, var-rem(--semantic-components-pricing-typography-font-size-minor-md));
        font-style: normal;
        line-height: var(--price--price-decimal--lh, var-rem(--semantic-components-pricing-typography-line-height-minor-md));
      }

      .price__price-value {
        align-items: flex-start;
        font-size: var(--price--price-value--fs, var-rem(--semantic-components-pricing-typography-font-size-major-md));
        line-height: var(--price--price-value--lh, var-rem(--semantic-components-pricing-typography-line-height-major-md));
      }
    }
  }

  .pricing__price-frequency {
    font-size: var(--pricing--price-frequency--fs, var-rem(--semantic-typography-font-size-xs));
    line-height: var(--pricing--price-frequency--lh, var-rem(--semantic-typography-line-height-caption-md));
  }

  .pricing__price-promo-duration {
    font-size: var(--pricing--price-promo-duration--fs, var-rem(--semantic-typography-font-size-xs));
    line-height: var(--pricing--price-promo-duration--lh, var-rem(--semantic-typography-line-height-caption-md));
  }

  .pricing__price-frequency {
    margin-left: var(--pricing--price-frequency--margin, var-rem(--semantic-spacing-3xs));
    color: var(--pricing--price-patch-color, var(--semantic-color-text-default));
  }

  .pricing__price-promo-duration {
    color: var(--pricing--price-patch-color, var(--semantic-color-text-subtle));
  }

  .currency-after {
    flex-direction: row-reverse;
    gap: var-rem(--semantic-spacing-3xs);
    justify-content: start;
  }

  .pricing__footer.price-align__center,
  .pricing__footer.price-align__right {
    display: flex;
  }

  .pricing__footer.price-align__center {
    justify-content: center;
  }

  .pricing__footer.price-align__right {
    justify-content: flex-end;
  }
}

:host([appearance='patch']) {
  @include media('from-lg') {
    --pricing--price-value-wrapper--padding: var-rem(--semantic-spacing-none);
    --pricing--price-frequency--margin: var-rem(--semantic-spacing-none);
    --pricing--price-patch-color: var(--semantic-components-pricing-color-text-price-patch);
    --pricing--price-promo-price--fs: #{var-rem(--semantic-typography-font-size-2xs)};
    --pricing--price-promo-price--lh: #{var-rem(--semantic-typography-line-height-xs)};
    --pricing--price-promo-duration--fs: #{var-rem(--semantic-typography-font-size-3xs)};
    --pricing--price-promo-duration--lh: #{var-rem(--semantic-typography-line-height-3xs)};
    --pricing--price-frequency--fs: #{var-rem(--semantic-typography-font-size-xs)};
    --pricing--price-frequency--lh: #{var-rem(--semantic-typography-line-height-xs)};
    --pricing--price-currency--fs: #{var-rem(--semantic-components-pricing-typography-font-size-price-patch-currency)};
    --pricing--price-currency--ls: #{var-rem(--semantic-components-pricing-typography-line-height-price-patch-currency)};
    --price--price-value--fs: #{var-rem(--semantic-components-pricing-typography-font-size-price-patch-major)};
    --price--price-value--lh: #{var-rem(--semantic-components-pricing-typography-line-height-price-patch-major)};
    --price--price-decimal--lh: #{var-rem(--semantic-components-pricing-typography-line-height-price-patch-minor)};
    --price--price-decimal--fs: #{var-rem(--semantic-components-pricing-typography-font-size-price-patch-minor)};
    --pricing--price-value-wrapper--fw: var(--semantic-components-pricing-typography-font-weight-price-patch);
    --pricing--price-value-wrapper--margin: 0.2rem;

    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    aspect-ratio: 1 / 1;
    min-width: wink-rem(12.8);
    min-height: wink-rem(12.8);
    padding: var-rem(--semantic-spacing-xs);
    background-color: var(--pricing-host-background, var(--semantic-color-brand-default));
    background-repeat: no-repeat;
    background-size: cover;

    .pricing__starting-from {
      @include media('from-lg') {
        font-size: var-rem(--semantic-typography-font-size-2xs);
        line-height: var-rem(--semantic-typography-line-height-xs);
        font-weight: var(--wink-pricing-patch--starting-from--fw, var(--semantic-typography-font-weight-bold));
      }
    }

    .pricing__price-frequency {
      @include media('from-lg') {
        font-weight: var(--wink-pricing-patch--starting-from--fw, var(--semantic-typography-font-weight-bold));
      }
    }
  }
  @include media('until-lg') {
    .pricing__header.price-align__center {
      justify-content: start;

      @include media('from-lg') {
        flex-direction: column;
        align-items: center;
      }
    }

    .pricing__current-price-wrapper.price-align__center {
      flex-direction: row;
      align-items: flex-end;
    }

    .pricing__footer.price-align__center {
      justify-content: start;
    }
  }
}

:host([appearance='subtle text']),
:host([appearance='compact']) {
  --pricing--price-value-wrapper--fw: var(--semantic-typography-font-weight-bold);
  --price--price-value--fs: #{var-rem(--semantic-components-pricing-typography-font-size-major-sm)};
  --price--price-value--lh: #{var-rem(--semantic-components-pricing-typography-line-height-major-sm)};
  --price--price-decimal--lh: #{var-rem(--semantic-components-pricing-typography-line-height-minor-sm)};
  --price--price-decimal--fs: #{var-rem(--semantic-components-pricing-typography-font-size-minor-sm)};
  --pricing--header--lh: #{var-rem(--semantic-typography-line-height-caption-md)};
  --pricing--price-currency--fs: #{var-rem(--semantic-components-pricing-typography-font-size-currency-sm)};
  --pricing--price-currency--ls: #{var-rem(--semantic-components-pricing-typography-line-height-currency-sm)};
  .pricing__price-value-wrapper {
    align-items: center;
  }
}

:host([appearance='compact']) {
  .pricing__top {
    flex-direction: row;
    gap: var-rem(--semantic-spacing-2xs);
    align-items: center;
  }

  .pricing__header,
  .pricing__current-price-wrapper,
  .pricing__footer {
    display: flex;
    flex-direction: row;
    width: auto;
  }

  .pricing__header {
    margin-bottom: 0;
  }

  &:has(.price-align__center) {
    justify-content: center;

    .pricing__top {
      justify-content: center;
    }
  }

  &:has(.price-align__right) {
    justify-content: flex-end;

    .pricing__top {
      justify-content: flex-end;
    }
  }
}
